import { useNavigate } from "react-router-dom";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import Et3CustomizedButton from "../../../../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import {
  COUNTER_ARROW_FONT_SIZE,
  COUNTER_ARROW_SIZE,
  COUNTER_FONT_SIZE,
  COUNTER_PILL_HEIGHT,
  COUNTER_PILL_PADDING,
  COUNTER_PILL_RADIUS_CSS,
  COUNTER_PILL_WIDTH
} from "./counter-index-constants";

const UserCounterIndex = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isVisible = getUserAdvancedStore().userIDs.get().length > 0;
  const index = getUserAdvancedStore().currentIndex.get();
  const navigate = useNavigate();
  const pathname = window.location.pathname;

  return isVisible ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={COUNTER_PILL_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{ width: "auto", flexShrink: 0, marginLeft: "auto" }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={COUNTER_PILL_WIDTH}
        height={COUNTER_PILL_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.bondiBlue}
        style={{
          boxSizing: "border-box",
          color: colors.all.white,
          borderRadius: COUNTER_PILL_RADIUS_CSS,
          paddingLeft: COUNTER_PILL_PADDING * unitX,
          paddingRight: COUNTER_PILL_PADDING * unitX
        }}
        onClick={() => {}}
      >
        <Et3CustomizedButton
          style={{
            color: colors.all.white
          }}
          withShadow={false}
          width={COUNTER_ARROW_SIZE}
          height={COUNTER_ARROW_SIZE}
          fDirection="row"
          justifyContent="center"
          alignItems="center"
          isEnabled={true}
          color={colors.all.transparent}
          onClick={() => {
            getUserAdvancedStore().setPrevUser();
            navigate({
              pathname: pathname,
              search: `?id=${getUserAdvancedStore().currentUserId.get()}`
            });
          }}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={COUNTER_ARROW_FONT_SIZE}
            text={"<"}
            isSpan={false}
            color={colors.all.white}
            style={{}}
          />
        </Et3CustomizedButton>
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={COUNTER_FONT_SIZE}
          text={`${index + 1} / ${getUserAdvancedStore().userIDs.get().length}`}
          isSpan={false}
          color={colors.all.white}
          style={{}}
        />
        <Et3CustomizedButton
          style={{
            color: colors.all.white
          }}
          withShadow={false}
          width={COUNTER_ARROW_SIZE}
          height={COUNTER_ARROW_SIZE}
          fDirection="row"
          justifyContent="center"
          alignItems="center"
          isEnabled={true}
          color={colors.all.transparent}
          onClick={() => {
            getUserAdvancedStore().setNextUser();
            navigate({
              pathname: pathname,
              search: `?id=${getUserAdvancedStore().currentUserId.get()}`
            });
          }}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={COUNTER_ARROW_FONT_SIZE}
            text={">"}
            isSpan={false}
            color={colors.all.white}
            style={{}}
          />
        </Et3CustomizedButton>
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default UserCounterIndex;
